import { render, staticRenderFns } from "./service_detail.vue?vue&type=template&id=6d20b4c9&"
import script from "./service_detail.vue?vue&type=script&lang=js&"
export * from "./service_detail.vue?vue&type=script&lang=js&"
import style0 from "./service_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports